import { Web3Provider } from '@ethersproject/providers';
import { useWeb3React } from '@web3-react/core';
import InputBigAmount from 'components/InputBigAmount';
import { BigNumber } from 'ethers';
import { parseUnits } from 'ethers/lib/utils';
import useTowerUnstake from 'hooks/useTowerUnstake';
import { useState } from 'react';
import { InteractionModalContainer } from '.';
import InteractionButton from '../InteractionButton';

/**
 * Props for the unstake interaction modal.
 * @property show Shows or hides the modal.
 * @property toggleShow A function to update the show variable to show or hide the Modal.
 */
export interface TowerUnstakeInteractionModalProps {
  show: boolean;
  toggleShow(s: boolean): void;
  towerPoolAddress: string;
  stakedBalance: BigNumber;
  stakedDecimals: BigNumber;
  stakedSymbol: string;
}

export default function TowerUnstakeInteractionModal({ show, toggleShow, towerPoolAddress, stakedSymbol, stakedBalance, stakedDecimals }: TowerUnstakeInteractionModalProps): JSX.Element {
  const [val, setVal] = useState<string>('0');

  const { chainId } = useWeb3React<Web3Provider>();

  if (!chainId) {
    throw new Error('Invalid chain ID!');
  }
  const bigAmount = stakedBalance;
  const decimals = stakedDecimals;

  const amount = parseUnits(val, decimals);
  const invalidInput = amount.gt(bigAmount) || amount.eq(0);
  const [unstakeState, unstake] = useTowerUnstake(towerPoolAddress, amount, decimals, invalidInput);

  const onUnstake = async () => {
    await unstake();
    setVal('0');
    toggleShow(false);
  };

  return (
    <InteractionModalContainer
      title='Unstake'
      show={show}
      toggleShow={toggleShow}>
      <>
        <InputBigAmount
          val={val}
          setVal={setVal}
          suffix={stakedSymbol}
          availableSuffix={`${stakedSymbol}\u00A0`}
          availableTitle='Available'
          available={bigAmount}
          max={bigAmount}
          decimals={decimals} />
        <div className='text-xs sm:text-sm text-textSecondary'>Pending rewards (if any) will not be claimed.</div>
        <div className='mt-4 flex justify-end'>
          <InteractionButton
            name='Unstake'
            onCall={onUnstake}
            state={unstakeState} />
        </div>
      </>
    </InteractionModalContainer>
  );
}
